<section
  class="flex h-full flex-col justify-start gap-4 rounded-lg bg-primary-50 p-4"
>
  @if (wasteForm) {
    <div class="flex flex-row items-center justify-between">
      <h3 class="text-primary-900">
        {{ "calculator.waste" | transloco }}
      </h3>
      <p-button icon="pi pi-times" variant="text" (click)="confirmDelete()" />
    </div>
    <form [formGroup]="wasteForm" class="flex h-full flex-col">
      <div class="flex flex-1 flex-col px-4 pt-6">
        <div class="flex flex-col">
          <label
            for="wasteType"
            class="text-paragraph-xs-med text-greyscale-700"
            >{{ "calculator.label.wasteType" | transloco }}
          </label>
          <p-select
            id="wasteType"
            formControlName="type"
            [options]="[
              {
                label: 'categoryType.normal' | transloco,
                value: 'normal',
              },
              {
                label: 'categoryType.specialAttention' | transloco,
                value: 'specialAttention',
              },
              {
                label: 'categoryType.zeroWaste' | transloco,
                value: 'zeroWaste',
              },
              {
                label: 'categoryType.specific' | transloco,
                value: 'specific',
              },
            ]"
            [placeholder]="'calculator.placeholder.wasteType' | transloco"
          />
        </div>
        @if (wasteForm.get("type")?.value === "specific") {
          <div class="flex flex-row gap-4">
            <div class="flex flex-1 flex-col">
              <label
                for="kgOfPlastic"
                class="text-paragraph-xs-med text-greyscale-700"
                >{{ "calculator.label.kgOfPlastic" | transloco }}
                <app-tooltip-icon
                  position="right"
                  [message]="'calculator.plasticWasteTooltip' | transloco"
              /></label>
              <p-inputnumber
                id="kgOfPlastic"
                formControlName="kgOfPlastic"
                [placeholder]="'calculator.placeholder.kgOfPlastic' | transloco"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="20"
              />
            </div>

            <div class="flex flex-1 flex-col">
              <label
                for="kgOfNonPlastic"
                class="text-paragraph-xs-med text-greyscale-700"
                >{{ "calculator.label.kgOfNonPlastic" | transloco }}
                <app-tooltip-icon
                  position="right"
                  [message]="'calculator.nonPlasticWasteTooltip' | transloco"
              /></label>
              <p-inputnumber
                id="kgOfNonPlastic"
                formControlName="kgOfNonPlastic"
                [placeholder]="
                  'calculator.placeholder.kgOfNonPlastic' | transloco
                "
                class="flex-1"
                mode="decimal"
                [minFractionDigits]="0"
                [maxFractionDigits]="20"
              />
            </div>
          </div>
        }
      </div>
      <div class="flex justify-end p-4">
        <p-button
          [label]="'save' | transloco"
          (click)="submit()"
          [loading]="loading"
          [disabled]="wasteForm.invalid"
        />
      </div>
    </form>
  } @else {
    <app-prestation-empty-state
      [title]="'calculator.emptyState.waste.title' | transloco"
      [text]="'calculator.emptyState.waste.text' | transloco"
      [buttonLabel]="'calculator.addWaste' | transloco"
      [action]="createWasteForm"
    />
  }
</section>
